function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import styles from './SearchGacContainer.less';
import { GacInputField } from '../gacinput/GacInputField';
var SearchGacContainer = function SearchGacContainer(_ref) {
  var id = _ref.id,
    apiEndPoint = _ref.apiEndPoint,
    buttonText = _ref.buttonText,
    placeholder = _ref.placeholder,
    selectedSuggestion = _ref.selectedSuggestion,
    onSuggestionSelected = _ref.onSuggestionSelected,
    onSelectionSubmit = _ref.onSelectionSubmit,
    _ref$nextgenData = _ref.nextgenData,
    nextgenData = _ref$nextgenData === void 0 ? true : _ref$nextgenData,
    _ref$isSubmitting = _ref.isSubmitting,
    isSubmitting = _ref$isSubmitting === void 0 ? false : _ref$isSubmitting;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expandedView = _useState2[0],
    expandSearchBlock = _useState2[1];
  var expandedStyle = expandedView ? styles.expanded : '';
  useEffect(function () {
    var body = document.getElementsByTagName('body')[0];
    expandedView ? body.classList.add("".concat(styles.overlayOpened)) : setTimeout(function () {
      return body.classList.remove("".concat(styles.overlayOpened));
    }, 650);
  }, [expandedView]);
  var onfocus = function onfocus() {
    if (!expandedView) {
      expandSearchBlock(true);
    }
  };
  var onClose = function onClose() {
    if (expandedView) {
      expandSearchBlock(false);
    }
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!isSubmitting) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            onClose();
            _context.n = 2;
            return onSelectionSubmit === null || onSelectionSubmit === void 0 ? void 0 : onSelectionSubmit();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function onSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-flex one-whole margin-left-none background-white"
  }, /*#__PURE__*/React.createElement(Overlay, {
    expandedView: expandedView,
    expandedStyle: expandedStyle,
    submitButtonText: buttonText,
    onSubmit: onSubmit,
    isSubmitting: isSubmitting
  }), /*#__PURE__*/React.createElement(CloseButton, {
    expandedView: expandedView,
    expandedStyle: expandedStyle,
    onClose: onClose
  }), /*#__PURE__*/React.createElement("div", {
    className: "grid-item input-text-container one-whole absolute-reference"
  }, /*#__PURE__*/React.createElement(GacInputField, {
    id: id,
    className: "one-whole ".concat(styles.gacContainer, " ").concat(expandedView ? styles.expandGac : ''),
    onFocus: onfocus,
    apiEndPoint: apiEndPoint,
    onSuggestionSelected: onSuggestionSelected,
    keepFocus: true,
    placeholder: placeholder,
    nextgenData: nextgenData,
    selectedSuggestion: selectedSuggestion,
    icon: true
  })));
};
var CloseButton = function CloseButton(_ref3) {
  var expandedView = _ref3.expandedView,
    expandedStyle = _ref3.expandedStyle,
    onClose = _ref3.onClose;
  return /*#__PURE__*/React.createElement("button", {
    className: "button-icon-standalone padding-none ".concat(styles.closeButton, " ").concat(expandedView && expandedStyle),
    onClick: onClose
  }, /*#__PURE__*/React.createElement("span", {
    className: "is24-icon-closing font-regular"
  }));
};
var Overlay = function Overlay(_ref4) {
  var onSubmit = _ref4.onSubmit,
    expandedView = _ref4.expandedView,
    expandedStyle = _ref4.expandedStyle,
    submitButtonText = _ref4.submitButtonText,
    isSubmitting = _ref4.isSubmitting;
  return /*#__PURE__*/React.createElement("div", {
    className: "one-whole background-white padding-xl ".concat(styles.hiddenBlock, " ").concat(expandedView && expandedStyle)
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onSubmit,
    className: "button button-primary ".concat(styles.hiddenButton, " ").concat(expandedView && expandedStyle),
    type: "button",
    "data-testid": "makler_finden_overlay",
    disabled: isSubmitting,
    "aria-busy": isSubmitting
  }, submitButtonText));
};
export default SearchGacContainer;